import { cl, CustomElement } from '@/utils';

export default class Map extends CustomElement {
  static component = 'b-map';
  static observedAttributes = ['place'];
  key = '';
  observe = true;
  zoom = '16';
  place = '';
  mapId = '';

  init() {
    this.mapId = this.getAttribute('map-id') || '16';
    this.zoom = this.getAttribute('zoom') || '16';
    this.place = this.getAttribute('place') || '';
    this.key = this.getAttribute('key') || '';
  }

  async initObserved() {
    const mapEl = document.createElement('div');
    mapEl.classList.add('h-full');
    this.appendChild(mapEl);

    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { Place } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const map = new Map(mapEl, {
      mapId: this.mapId,
      zoom: Number(this.zoom),
    });

    const { places } = await Place.searchByText({
      textQuery: this.place,
      fields: ['displayName', 'location', 'businessStatus'],
    });

    if (places.length) {
      map.setCenter(places[0].location);

      new AdvancedMarkerElement({
        position: places[0].location,
        map,
        title: places[0].displayName,
      });
    }
  }
}
